import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  const categories = [
    {
      id: 1,
      name: 'Livres Personnalisés',
      description: 'Des livres illustrés où votre enfant devient le héros de l\'histoire. Prénom, âge, univers, apparence : chaque récit est créé sur mesure, dans un style doux et inspiré du cinéma d\'animation. À lire sur tablette, téléphone ou ordinateur.',
      icon: '📚',
      gradient: 'from-blue-400 to-blue-600',
      image: 'https://public.readdy.ai/ai/img_res/ca3a76c2fb5ce2e8b64abbc79678d1de.jpg',
    },
    {
      id: 2,
      name: 'Films d\'animation',
      description: 'Les histoires prennent vie en vidéo animée, avec images, musique et narration. Une expérience immersive, idéale pour émerveiller les enfants… et les parents. Parfait pour un cadeau original et mémorable.',
      icon: '🎭',
      gradient: 'from-purple-400 to-pink-600',
      image: 'https://readdy.ai/api/search-image?query=A%20cute%20animated%20cartoon%20character%20of%20a%20happy%20family%20with%20parents%20and%20children%20in%20Pixar%20Disney%20style%2C%20colorful%20outfits%2C%20expressive%20faces%2C%20simple%20pastel%20background%2C%203D%20rendered%20look%2C%20joyful%20poses%2C%20professional%20animation%20quality&width=400&height=500&seq=char1&orientation=portrait',
    },
    {
      id: 3,
      name: 'Faire-part & événements',
      description: 'Naissance, anniversaire, mariage, événement familial… Des faire-part animés et illustrés, modernes, personnalisés et faciles à partager. Une alternative créative aux cartes traditionnelles pour des envois sur les réseaux sociaux, sms.',
      icon: '💌',
      gradient: 'from-yellow-400 to-orange-500',
      image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20animated%20birthday%20party%20invitation%20card%20with%20balloons%20confetti%20and%20celebration%20elements%20in%20Pixar%20Disney%20style%2C%20vibrant%20colors%2C%20festive%20atmosphere%2C%20simple%20clean%20background%2C%20magical%20sparkles%2C%20cheerful%20design&width=400&height=500&seq=invite1&orientation=portrait',
    },
    {
      id: 4,
      name: 'Portraits & souvenirs animés',
      description: 'Transformez une photo en illustration stylisée ou en vidéo. Famille, enfants, moments de vie : vos images deviennent de véritables histoires visuelles. Idéal pour offrir ou conserver un souvenir unique.',
      icon: '🎨',
      gradient: 'from-green-400 to-teal-600',
      image: 'https://readdy.ai/api/search-image?query=A%20charming%20illustrated%20family%20portrait%20in%20Pixar%20Disney%20animation%20style%20showing%20parents%20children%20and%20a%20pet%20dog%2C%20warm%20colors%2C%20simple%20soft%20background%2C%20artistic%20rendering%2C%20heartwarming%20scene%2C%20professional%20quality%20illustration&width=400&height=500&seq=portrait1&orientation=portrait',
    },
  ];

  const steps = [
    {
      number: 1,
      title: 'Vous choisissez',
      description: 'Le type de création.',
      icon: 'ri-cursor-line',
    },
    {
      number: 2,
      title: 'Vous personnalisez',
      description: 'Prénom, âge, style graphique, photos, options…',
      icon: 'ri-edit-line',
    },
    {
      number: 3,
      title: 'Vous validez & payez',
      description: 'Vous vérifiez le récapitulatif, puis vous réglez en toute sécurité via Stripe.',
      icon: 'ri-secure-payment-line',
    },
    {
      number: 4,
      title: 'Nous créons',
      description: 'votre projet sur mesure, dans l\'univers choisi.',
      icon: 'ri-brush-line',
    },
    {
      number: 5,
      title: 'Vous recevez',
      description: 'Votre création est livrée en format numérique, prête à être lue, regardée ou partagée.',
      icon: 'ri-mail-send-line',
    },
  ];

  const featuredProducts = [
    {
      id: 1,
      name: 'Histoire de Noël Personnalisée',
      category: 'Livre Numérique',
      price: '29.90',
      badge: 'Populaire',
      image: 'https://readdy.ai/api/search-image?query=A%20magical%20Christmas%20storybook%20cover%20with%20a%20child%20character%20in%20winter%20wonderland%20with%20Santa%20and%20reindeer%2C%20snow%20falling%2C%20warm%20lights%2C%20Pixar%20Disney%20style%2C%20festive%20colors%2C%20simple%20clean%20background%2C%20enchanting%20holiday%20atmosphere&width=400&height=400&seq=xmas1&orientation=squarish',
    },
    {
      id: 2,
      name: 'Portrait Famille Animé',
      category: 'Portrait Illustré',
      price: '39.90',
      badge: 'Nouveau',
      image: 'https://readdy.ai/api/search-image?query=An%20animated%20family%20portrait%20showing%20happy%20parents%20with%20two%20children%20in%20Pixar%20Disney%20style%2C%20colorful%20clothing%2C%20warm%20expressions%2C%20simple%20pastel%20background%2C%20professional%20illustration%20quality%2C%20heartwarming%20scene&width=400&height=400&seq=fam1&orientation=squarish',
    },
    {
      id: 3,
      name: 'Invitation Anniversaire Vidéo',
      category: 'Invitation Animée',
      price: '24.90',
      badge: 'Tendance',
      image: 'https://readdy.ai/api/search-image?query=A%20vibrant%20animated%20birthday%20invitation%20with%20balloons%20cake%20and%20party%20decorations%20in%20Pixar%20Disney%20style%2C%20bright%20cheerful%20colors%2C%20simple%20clean%20background%2C%20festive%20celebration%20elements%2C%20magical%20sparkles&width=400&height=400&seq=birth1&orientation=squarish',
    },
    {
      id: 4,
      name: 'Personnage Enfant 3D',
      category: 'Personnage Animé',
      price: '34.90',
      badge: 'Bestseller',
      image: 'https://readdy.ai/api/search-image?query=A%20cute%203D%20animated%20child%20character%20in%20Pixar%20Disney%20style%20with%20big%20expressive%20eyes%2C%20colorful%20outfit%2C%20happy%20pose%2C%20simple%20gradient%20background%2C%20professional%203D%20rendering%2C%20charming%20personality&width=400&height=400&seq=kid1&orientation=squarish',
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const exampleCreations = [
    {
      id: 1,
      title: 'Histoire de Princesse',
      category: 'Livre Illustré',
      image: 'https://readdy.ai/api/search-image?query=A%20beautiful%20illustrated%20storybook%20page%20showing%20a%20young%20girl%20princess%20character%20in%20a%20magical%20castle%20with%20sparkles%20and%20fairy%20tale%20elements%2C%20Pixar%20Disney%20animation%20style%2C%20vibrant%20colors%2C%20simple%20clean%20background%2C%20enchanting%20atmosphere%2C%20professional%20children%20book%20illustration&width=800&height=600&seq=example1&orientation=landscape',
    },
    {
      id: 2,
      title: 'Aventure Spatiale',
      category: 'Film d\'Animation',
      image: 'https://readdy.ai/api/search-image?query=An%20animated%20space%20adventure%20scene%20with%20a%20child%20astronaut%20character%20floating%20among%20colorful%20planets%20and%20stars%2C%20Pixar%20Disney%20style%2C%20bright%20cheerful%20colors%2C%20simple%20gradient%20background%2C%20magical%20cosmic%20atmosphere%2C%20professional%20animation%20quality&width=800&height=600&seq=example2&orientation=landscape',
    },
    {
      id: 3,
      title: 'Faire-part Naissance',
      category: 'Faire-part Animé',
      image: 'https://readdy.ai/api/search-image?query=A%20sweet%20animated%20birth%20announcement%20card%20with%20cute%20baby%20character%20surrounded%20by%20soft%20clouds%20balloons%20and%20pastel%20colors%2C%20Pixar%20Disney%20style%2C%20gentle%20warm%20atmosphere%2C%20simple%20clean%20background%2C%20magical%20sparkles%2C%20professional%20design&width=800&height=600&seq=example3&orientation=landscape',
    },
    {
      id: 4,
      title: 'Portrait Famille',
      category: 'Portrait Illustré',
      image: 'https://readdy.ai/api/search-image?query=A%20charming%20illustrated%20family%20portrait%20showing%20parents%20with%20children%20in%20cartoon%20style%2C%20happy%20expressions%2C%20colorful%20outfits%2C%20Pixar%20Disney%20animation%20aesthetic%2C%20simple%20soft%20background%2C%20warm%20loving%20atmosphere%2C%20professional%20illustration&width=800&height=600&seq=example4&orientation=landscape',
    },
    {
      id: 5,
      title: 'Histoire de Dinosaures',
      category: 'Livre Illustré',
      image: 'https://readdy.ai/api/search-image?query=An%20illustrated%20storybook%20page%20with%20a%20child%20character%20discovering%20friendly%20cartoon%20dinosaurs%20in%20a%20prehistoric%20jungle%2C%20Pixar%20Disney%20style%2C%20vibrant%20green%20colors%2C%20simple%20clean%20background%2C%20adventurous%20atmosphere%2C%20professional%20children%20book%20art&width=800&height=600&seq=example5&orientation=landscape',
    },
    {
      id: 6,
      title: 'Invitation Anniversaire',
      category: 'Faire-part Animé',
      image: 'https://readdy.ai/api/search-image?query=A%20festive%20animated%20birthday%20invitation%20with%20party%20decorations%20balloons%20cake%20and%20celebration%20elements%2C%20Pixar%20Disney%20style%2C%20bright%20cheerful%20colors%2C%20simple%20clean%20background%2C%20joyful%20atmosphere%2C%20professional%20design%20quality&width=800&height=600&seq=example6&orientation=landscape',
    },
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % exampleCreations.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + exampleCreations.length) % exampleCreations.length);
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center pt-20 overflow-hidden">
        {/* Background Gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50"></div>
        
        {/* Floating Elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <motion.div
            animate={{ y: [0, -20, 0], rotate: [0, 5, 0] }}
            transition={{ duration: 4, repeat: Infinity }}
            className="absolute top-20 left-10 text-6xl"
          >
            ⭐
          </motion.div>
          <motion.div
            animate={{ y: [0, 20, 0], rotate: [0, -5, 0] }}
            transition={{ duration: 5, repeat: Infinity }}
            className="absolute top-40 right-20 text-5xl"
          >
            💫
          </motion.div>
          <motion.div
            animate={{ y: [0, -15, 0] }}
            transition={{ duration: 3, repeat: Infinity }}
            className="absolute bottom-40 left-20 text-4xl"
          >
            🎨
          </motion.div>
        </div>

        <div className="max-w-7xl mx-auto px-6 py-20 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-primary-yellow/20 to-primary-coral/20 rounded-full mb-6">
                <span className="text-2xl">✨</span>
                <span className="font-quicksand font-semibold text-gray-800">
                  Nouveau : Histoires de Noël personnalisées
                </span>
              </div>

              {/* Main Title */}
              <h1 className="text-6xl lg:text-7xl font-fredoka font-bold leading-tight mb-6">
                Bienvenue dans l'univers{' '}
                <span className="bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent">
                  Pixel Anim
                </span>
              </h1>

              {/* Subtitle */}
              <p className="text-xl font-quicksand text-gray-700 leading-relaxed mb-4">
                Chez <strong>Pixel Anim</strong>, nous créons des <strong>ebooks personnalisés, des films d'animation et des créations visuelles sur mesure</strong>, pour les enfants comme pour les adultes, dans un <strong>univers cartoon créatif et moderne</strong>.
              </p>
              <p className="text-xl font-quicksand text-gray-700 leading-relaxed mb-4">
                Histoires illustrées, vidéos animées, faire-part, portraits ou souvenirs revisités : chaque projet est imaginé à partir de vos idées, de vos images et de vos envies, pour donner naissance à une <strong>création unique</strong>.
              </p>
              <p className="text-lg font-quicksand text-gray-600 leading-relaxed mb-8 italic">
                Pixel, notre mascotte, vous accompagne tout au long du site pour vous guider simplement dans votre projet.
              </p>

              {/* CTA Buttons */}
              <div className="flex flex-wrap gap-4 mb-8">
                <Link
                  to="/creations"
                  className="px-8 py-4 bg-gray-900 text-white font-quicksand font-bold rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <span>Découvrir nos créations</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/fonctionnement"
                  className="px-8 py-4 bg-white border-2 border-gray-900 text-gray-900 font-quicksand font-bold rounded-full hover:bg-gray-50 transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
                >
                  <i className="ri-play-circle-line"></i>
                  <span>Voir comment ça marche</span>
                </Link>
              </div>
            </motion.div>

            {/* Right Column - Hero Image */}
            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative"
            >
              <div className="relative rounded-5xl overflow-hidden shadow-soft-lg">
                <div className="w-full h-[700px]">
                  <img
                    src="https://static.readdy.ai/image/eb276de5dddb9e260b685871ba0dd98c/77143dad5c0be944306299d608ceda9f.png"
                    alt="Créations magiques Pixel Anim"
                    className="w-full h-full object-contain"
                  />
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-6">
              Nos Créations{' '}
              <span className="bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent">
                Personnalisées
              </span>
            </h2>
            <p className="text-xl font-quicksand text-gray-600 max-w-3xl mx-auto">
              Découvrez nos différentes catégories de créations numériques pour tous vos moments spéciaux
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Category 1 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              <Link
                to="/livres-personnalises"
                className="group block bg-gradient-to-br from-blue-50 to-blue-100 rounded-3xl p-8 hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-3xl">📚</span>
                </div>
                <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-3">
                  Livres Personnalisés
                </h3>
                <p className="font-quicksand text-gray-600 mb-4">
                  Histoires magiques où votre enfant devient le héros de l'aventure
                </p>
                <div className="flex items-center gap-2 text-primary-blue font-quicksand font-semibold">
                  <span>Découvrir</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </Link>
            </motion.div>

            {/* Category 2 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Link
                to="/films-animation"
                className="group block bg-gradient-to-br from-purple-50 to-pink-100 rounded-3xl p-8 hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-400 to-pink-600 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-3xl">🎬</span>
                </div>
                <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-3">
                  Films d'Animation
                </h3>
                <p className="font-quicksand text-gray-600 mb-4">
                  Vidéos animées personnalisées pour immortaliser vos moments précieux
                </p>
                <div className="flex items-center gap-2 text-purple-600 font-quicksand font-semibold">
                  <span>Découvrir</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </Link>
            </motion.div>

            {/* Category 3 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              <Link
                to="/creations"
                className="group block bg-gradient-to-br from-yellow-50 to-orange-100 rounded-3xl p-8 hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-yellow-400 to-orange-500 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-3xl">💌</span>
                </div>
                <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-3">
                  Faire-part & Événements
                </h3>
                <p className="font-quicksand text-gray-600 mb-4">
                  Invitations uniques et mémorables pour tous vos événements spéciaux
                </p>
                <div className="flex items-center gap-2 text-orange-600 font-quicksand font-semibold">
                  <span>Découvrir</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </Link>
            </motion.div>

            {/* Category 4 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              <Link
                to="/portraits"
                className="group block bg-gradient-to-br from-green-50 to-teal-100 rounded-3xl p-8 hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-green-400 to-teal-600 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-3xl">🎨</span>
                </div>
                <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-3">
                  Portraits Illustrés
                </h3>
                <p className="font-quicksand text-gray-600 mb-4">
                  Portraits artistiques de votre famille, couples et animaux de compagnie
                </p>
                <div className="flex items-center gap-2 text-teal-600 font-quicksand font-semibold">
                  <span>Découvrir</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </Link>
            </motion.div>

            {/* Category 5 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              <Link
                to="/nouveautes"
                className="group block bg-gradient-to-br from-pink-50 to-rose-100 rounded-3xl p-8 hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-pink-400 to-rose-600 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-3xl">✨</span>
                </div>
                <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-3">
                  Nouveautés
                </h3>
                <p className="font-quicksand text-gray-600 mb-4">
                  Découvrez nos dernières créations et collections exclusives
                </p>
                <div className="flex items-center gap-2 text-rose-600 font-quicksand font-semibold">
                  <span>Découvrir</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </Link>
            </motion.div>

            {/* Category 6 - NEW */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.6 }}
            >
              <Link
                to="/creations"
                className="group block bg-gradient-to-br from-amber-50 to-amber-100 rounded-3xl p-8 hover:shadow-soft-lg transition-all duration-300 hover:-translate-y-2 cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-amber-400 to-amber-600 rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  <span className="text-3xl">📸</span>
                </div>
                <h3 className="text-2xl font-fredoka font-bold text-gray-900 mb-3">
                  Retouche & Animation de photos anciennes
                </h3>
                <p className="font-quicksand text-gray-600 mb-4">
                  Redonnez vie à vos photos anciennes avec restauration et animation
                </p>
                <div className="flex items-center gap-2 text-amber-600 font-quicksand font-semibold">
                  <span>Découvrir</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform duration-300"></i>
                </div>
              </Link>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Examples Carousel Section */}
      <section className="py-24 bg-gradient-to-br from-blue-100 via-purple-100 to-pink-100 relative overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-20 left-10 w-32 h-32 bg-primary-yellow/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-primary-mint/20 rounded-full blur-3xl"></div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl font-fredoka font-bold text-gray-900 mb-6 leading-tight">
              Exemples de{' '}
              <span className="bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent">
                créations
              </span>
            </h2>
            <p className="text-xl font-quicksand text-gray-700 max-w-4xl mx-auto leading-relaxed">
              Découvrez quelques exemples de <strong>livres illustrés, films d'animation, faire-part et portraits personnalisés</strong> réalisés dans l'univers Pixel Anim. Chaque création présentée est unique et conçue à partir d'un projet réel.
            </p>
          </motion.div>

          {/* Carousel */}
          <div className="relative">
            {/* Main Carousel Container */}
            <div className="relative overflow-hidden rounded-3xl bg-white shadow-soft-lg">
              {/* Slides */}
              <div className="relative w-full h-[500px]">
                {exampleCreations.map((creation, index) => (
                  <div
                    key={creation.id}
                    className={`absolute inset-0 transition-opacity duration-500 ${
                      index === currentSlide ? 'opacity-100 z-10' : 'opacity-0 z-0'
                    }`}
                  >
                    <div className="w-full h-full flex flex-col lg:flex-row">
                      {/* Image */}
                      <div className="w-full lg:w-2/3 h-64 lg:h-full">
                        <img
                          src={creation.image}
                          alt={creation.title}
                          className="w-full h-full object-cover"
                        />
                      </div>

                      {/* Content */}
                      <div className="w-full lg:w-1/3 p-8 lg:p-12 flex flex-col justify-center">
                        <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-primary-blue/20 to-purple-600/20 rounded-full mb-4 w-fit">
                          <i className="ri-bookmark-line text-primary-blue"></i>
                          <span className="font-quicksand font-semibold text-gray-800">
                            {creation.category}
                          </span>
                        </div>
                        <h3 className="text-3xl lg:text-4xl font-fredoka font-bold text-gray-900 mb-4">
                          {creation.title}
                        </h3>
                        <p className="font-quicksand text-gray-600 mb-6">
                          Un exemple de création personnalisée réalisée dans l'univers Pixel Anim
                        </p>
                        <Link
                          to="/creations"
                          className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white font-quicksand font-bold rounded-full hover:bg-primary-blue transition-all duration-300 whitespace-nowrap cursor-pointer w-fit"
                        >
                          <span>Créer la vôtre</span>
                          <i className="ri-arrow-right-line"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Navigation Buttons */}
              <button
                onClick={prevSlide}
                className="absolute left-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-soft hover:shadow-soft-lg transition-all duration-300 cursor-pointer z-20"
                aria-label="Précédent"
              >
                <i className="ri-arrow-left-s-line text-2xl text-gray-900"></i>
              </button>
              <button
                onClick={nextSlide}
                className="absolute right-4 top-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-white/90 hover:bg-white rounded-full shadow-soft hover:shadow-soft-lg transition-all duration-300 cursor-pointer z-20"
                aria-label="Suivant"
              >
                <i className="ri-arrow-right-s-line text-2xl text-gray-900"></i>
              </button>
            </div>

            {/* Dots Indicator */}
            <div className="flex items-center justify-center gap-2 mt-8">
              {exampleCreations.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`h-3 rounded-full transition-all duration-300 cursor-pointer ${
                    index === currentSlide
                      ? 'bg-primary-blue w-8'
                      : 'bg-gray-300 hover:bg-gray-400 w-3'
                  }`}
                  aria-label={`Aller à la diapositive ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 className="text-5xl font-fredoka font-bold text-gray-900 mb-4">
              🧭 Comment ça marche ?
            </h2>
            <p className="text-xl font-quicksand text-gray-600">
              Simple, rapide et entièrement personnalisé
            </p>
          </div>

          {/* Steps Timeline */}
          <div className="relative">
            {/* Connection Line */}
            <div className="hidden lg:block absolute top-20 left-0 right-0 h-1 bg-gradient-to-r from-primary-blue via-primary-mint to-primary-coral"></div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
              {steps.map((step, index) => (
                <motion.div
                  key={step.number}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="relative"
                >
                  <div className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-all duration-300 border border-gray-100">
                    {/* Step Number */}
                    <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center bg-gradient-to-br from-primary-blue to-purple-600 rounded-full shadow-colored-blue">
                      <span className="text-3xl font-fredoka font-bold text-white">
                        {step.number}
                      </span>
                    </div>

                    {/* Icon */}
                    <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                      <i className={`${step.icon} text-4xl text-primary-blue`}></i>
                    </div>

                    {/* Content */}
                    <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3 text-center">
                      {step.title}
                    </h3>
                    <p className="font-quicksand text-gray-600 text-center leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* CTA */}
          <div className="text-center mt-12">
            <Link
              to="/fonctionnement"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-primary-blue to-purple-600 text-white font-quicksand font-bold rounded-full hover:shadow-colored-blue transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>En savoir plus</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Products Section */}
      <section className="py-24 bg-neutral-lighter">
        <div className="max-w-7xl mx-auto px-6">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl lg:text-5xl font-fredoka font-bold text-gray-900 mb-6">
              Pourquoi choisir{' '}
              <span className="bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent">
                Pixel Anim
              </span>
              {' '}?
            </h2>
            <p className="text-xl font-quicksand text-gray-600 max-w-3xl mx-auto">
              Des créations uniques, réalisées avec soin et livrées en toute sécurité
            </p>
          </motion.div>

          {/* Benefits Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Benefit 1 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-green-400 to-green-600 rounded-2xl mb-6">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                Paiement sécurisé via Stripe
              </h3>
              <p className="font-quicksand text-gray-600 leading-relaxed">
                Vos transactions sont protégées par Stripe, le leader mondial du paiement en ligne
              </p>
            </motion.div>

            {/* Benefit 2 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-purple-400 to-pink-600 rounded-2xl mb-6">
                <i className="ri-sparkling-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                Créations 100 % personnalisées
              </h3>
              <p className="font-quicksand text-gray-600 leading-relaxed">
                Chaque création est unique et conçue spécialement pour vous selon vos souhaits
              </p>
            </motion.div>

            {/* Benefit 3 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl mb-6">
                <i className="ri-rocket-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                Livraison numérique rapide
              </h3>
              <p className="font-quicksand text-gray-600 leading-relaxed">
                Recevez votre création directement par email, prête à être consultée et partagée
              </p>
            </motion.div>

            {/* Benefit 4 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.4 }}
              className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-400 to-teal-600 rounded-2xl mb-6">
                <i className="ri-devices-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                Lisible sur tous les écrans
              </h3>
              <p className="font-quicksand text-gray-600 leading-relaxed">
                Tablette, téléphone, ordinateur : profitez de vos créations où vous voulez
              </p>
            </motion.div>

            {/* Benefit 5 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
              className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl mb-6">
                <i className="ri-customer-service-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                Accompagnement simple et clair
              </h3>
              <p className="font-quicksand text-gray-600 leading-relaxed">
                Nous vous guidons à chaque étape pour créer facilement votre projet
              </p>
            </motion.div>

            {/* Benefit 6 */}
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.6 }}
              className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-all duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-rose-400 to-rose-600 rounded-2xl mb-6">
                <i className="ri-lock-2-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                Respect de vos images et de votre vie privée
              </h3>
              <p className="font-quicksand text-gray-600 leading-relaxed">
                Vos photos et informations personnelles sont traitées avec la plus grande confidentialité
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="relative py-32 overflow-hidden">
        {/* Background */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary-blue via-purple-600 to-primary-coral"></div>
        
        {/* Decorative Shapes */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-10 right-10 w-80 h-80 bg-white rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-5xl mx-auto px-6 text-center relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl lg:text-6xl font-fredoka font-bold text-white mb-6 leading-tight">
              Prêt à donner vie à votre première création{' '}
              <span className="bg-gradient-to-r from-primary-yellow via-primary-mint to-primary-coral bg-clip-text text-transparent">
                Pixel Anim
              </span>
              {' '}?
            </h2>
            <p className="text-xl font-quicksand text-white/90 mb-10">
              Imaginez une création unique, pensée pour vous, à lire, regarder et partager.
            </p>
            <Link
              to="/creations"
              className="inline-flex items-center gap-3 px-10 py-5 bg-white text-gray-900 font-quicksand font-bold text-lg rounded-full hover:shadow-soft-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <span>Commencer maintenant</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </Link>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}